export const productCarbonFootprintOptions = [
  {
    value: 'B2B',
  },
  {
    value: 'B2C',
  },
];

export const eachProductAnnualOptions = [
  {
    label: 'Raw Materials',
    value: 'stage1',
  },
  {
    label: 'Raw Materials Transportation',
    value: 'stage2',
  },
  {
    label: 'Processing Facility',
    value: 'stage3',
  },
  {
    label: 'Product Distribution and Storage',
    value: 'stage4',
  },
];

export const productTotalCarbonForEachCycle = [
  {
    label: '% of total',
    value: 'percentage',
  },
  {
    label: 'kgCO\u2082e',
    value: 'kg',
  },
];

export const productBreakdownTotalCarbonForEachCycle = [
  {
    label: '% of total',
    value: 'total',
  },
  {
    label: '% of stage',
    value: 'stage',
  },
  {
    label: 'kgCO\u2082e',
    value: 'kg',
  },
];
